
import { defineComponent } from 'vue';

import ProductAmountModeSection from '@/activities/modals/createEditActivity/components/ProductAmountModeSection.vue';
import { MergedActivityProduct } from '@/activities/modals/createEditActivity/services/MergedActivityProductsService';
import { Getters as CreateEditActivityGetters } from '@/activities/modals/createEditActivity/store/getters';
import { AmountType } from '@/activities/utils/amountsAndUnits/findUnit';

export default defineComponent({
  name: 'ProductAmountModeSectionContainer',
  components: { ProductAmountModeSection },
  computed: {
    mergedActivityProducts(): MergedActivityProduct[] {
      return this.$store.getters['activities/createEditActivity/mergedActivityProducts'];
    },
    mode(): AmountType {
      return this.$store.getters[
        'activities/createEditActivity/productAmountMode'
      ] as CreateEditActivityGetters['productAmountMode'];
    },
    // Only relevant once there is a product with a unit to describe.
    visible(): boolean {
      return this.mergedActivityProducts.some((activityProduct) => activityProduct.unitId);
    },
  },
  methods: {
    switchMode(): void {
      const nextMode = this.mode === AmountType.Total ? AmountType.PerHa : AmountType.Total;
      this.$store.dispatch('activities/createEditActivity/setProductAmountModeForAllProducts', nextMode);
    },
  },
});
